import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Collapse from '@mui/material/Collapse';
import {
  eventCard,
  desktopEventDot,
  desktopEventLine,
  eventContainer,
  getEventCardProps,
  timelineDialogStyles,
} from './actionLockTimelineStyles';
import { ActionLockEvent } from '../../../types/types';
import { useActionLockTimelineScroll } from '../../../hooks/useActionLockTimelineScroll';
import { format, parseISO } from 'date-fns';

interface ActionLockDesktopTimelineProps {
  events: ActionLockEvent[];
  selectedId: number | null;
  onSelect: (id: number) => void;
}

const ActionLockDesktopTimeline: React.FC<ActionLockDesktopTimelineProps> = ({
  events,
  selectedId,
  onSelect,
}) => {
  const itemRefs = useActionLockTimelineScroll<HTMLDivElement>(selectedId);

  return (
    <Box sx={timelineDialogStyles.desktopCard}>
      {events.map((event, index) => {
        const { isLeft, isSelected, isLast } = getEventCardProps(
          index,
          event.id,
          selectedId,
          events.length
        );

        return (
          <Box key={event.id} id={`event-${event.id}`} sx={eventContainer(isLeft)}>
            {!isLast && <Box sx={desktopEventLine()} />}
            <Box sx={desktopEventDot(isSelected)} />
            <Paper
              ref={(el) => el && (itemRefs.current[event.id] = el)}
              role="button"
              tabIndex={0}
              aria-expanded={isSelected}
              elevation={3}
              onClick={() => onSelect(event.id)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') onSelect(event.id);
              }}
              sx={eventCard(isSelected)}
            >
              <Typography variant="h6" sx={timelineDialogStyles.cardTitle}>
                Port {event.action} ({event.interfaces})
              </Typography>
              <Typography variant="subtitle2" color="text.secondary">
                {format(parseISO(`${event.locked_at}Z`), 'yyyy-MM-dd HH:mm')}
              </Typography>
              <Collapse in={isSelected}>
                <Typography variant="body2" sx={timelineDialogStyles.cardText}>
                  user: {event.user_email}
                </Typography>
              </Collapse>
            </Paper>
          </Box>
        );
      })}
    </Box>
  );
};

export default ActionLockDesktopTimeline;
